module.exports = __webpack_public_path__ + "static/Sawal_Back_Big-662ce5bab0872d251f7338c510c05789.png";